import { SelectOption } from '../types/shared.types';

export const COUNTRIES: Array<SelectOption> = [
  { id: 'US', label: 'United States' },
  { id: 'CA', label: 'Canada' },
  { id: 'AF', label: 'Afghanistan' },
  { id: 'AL', label: 'Albania' },
  { id: 'DZ', label: 'Algeria' },
  { id: 'AD', label: 'Andorra' },
  { id: 'AO', label: 'Angola' },
  { id: 'AG', label: 'Antigua and Barbuda' },
  { id: 'AR', label: 'Argentina' },
  { id: 'AM', label: 'Armenia' },
  { id: 'AU', label: 'Australia' },
  { id: 'AT', label: 'Austria' },
  { id: 'AZ', label: 'Azerbaijan' },
  { id: 'BS', label: 'Bahamas' },
  { id: 'BH', label: 'Bahrain' },
  { id: 'BD', label: 'Bangladesh' },
  { id: 'BB', label: 'Barbados' },
  { id: 'BY', label: 'Belarus' },
  { id: 'BE', label: 'Belgium' },
  { id: 'BZ', label: 'Belize' },
  { id: 'BJ', label: 'Benin' },
  { id: 'BT', label: 'Bhutan' },
  { id: 'BO', label: 'Bolivia' },
  { id: 'BA', label: 'Bosnia and Herzegovina' },
  { id: 'BW', label: 'Botswana' },
  { id: 'BR', label: 'Brazil' },
  { id: 'BN', label: 'Brunei' },
  { id: 'BG', label: 'Bulgaria' },
  { id: 'BF', label: 'Burkina Faso' },
  { id: 'BI', label: 'Burundi' },
  { id: 'CV', label: 'Cabo Verde' },
  { id: 'KH', label: 'Cambodia' },
  { id: 'CM', label: 'Cameroon' },
  { id: 'CF', label: 'Central African Republic' },
  { id: 'TD', label: 'Chad' },
  { id: 'CL', label: 'Chile' },
  { id: 'CN', label: 'China' },
  { id: 'CO', label: 'Colombia' },
  { id: 'KM', label: 'Comoros' },
  { id: 'CG', label: 'Congo' },
  { id: 'CD', label: 'Congo, Democratic Republic of the' },
  { id: 'CR', label: 'Costa Rica' },
  { id: 'CI', label: 'Côte d’Ivoire' },
  { id: 'HR', label: 'Croatia' },
  { id: 'CU', label: 'Cuba' },
  { id: 'CY', label: 'Cyprus' },
  { id: 'CZ', label: 'Czechia' },
  { id: 'DK', label: 'Denmark' },
  { id: 'DJ', label: 'Djibouti' },
  { id: 'DM', label: 'Dominica' },
  { id: 'DO', label: 'Dominican Republic' },
  { id: 'EC', label: 'Ecuador' },
  { id: 'EG', label: 'Egypt' },
  { id: 'SV', label: 'El Salvador' },
  { id: 'GQ', label: 'Equatorial Guinea' },
  { id: 'ER', label: 'Eritrea' },
  { id: 'EE', label: 'Estonia' },
  { id: 'SZ', label: 'Eswatini' },
  { id: 'ET', label: 'Ethiopia' },
  { id: 'FJ', label: 'Fiji' },
  { id: 'FI', label: 'Finland' },
  { id: 'FR', label: 'France' },
  { id: 'GA', label: 'Gabon' },
  { id: 'GM', label: 'Gambia' },
  { id: 'GE', label: 'Georgia' },
  { id: 'DE', label: 'Germany' },
  { id: 'GH', label: 'Ghana' },
  { id: 'GR', label: 'Greece' },
  { id: 'GD', label: 'Grenada' },
  { id: 'GT', label: 'Guatemala' },
  { id: 'GN', label: 'Guinea' },
  { id: 'GW', label: 'Guinea-Bissau' },
  { id: 'GY', label: 'Guyana' },
  { id: 'HT', label: 'Haiti' },
  { id: 'HN', label: 'Honduras' },
  { id: 'HU', label: 'Hungary' },
  { id: 'IS', label: 'Iceland' },
  { id: 'IN', label: 'India' },
  { id: 'ID', label: 'Indonesia' },
  { id: 'IR', label: 'Iran' },
  { id: 'IQ', label: 'Iraq' },
  { id: 'IE', label: 'Ireland' },
  { id: 'IL', label: 'Israel' },
  { id: 'IT', label: 'Italy' },
  { id: 'JM', label: 'Jamaica' },
  { id: 'JP', label: 'Japan' },
  { id: 'JO', label: 'Jordan' },
  { id: 'KZ', label: 'Kazakhstan' },
  { id: 'KE', label: 'Kenya' },
  { id: 'KI', label: 'Kiribati' },
  { id: 'KP', label: 'Korea, North' },
  { id: 'KR', label: 'Korea, South' },
  { id: 'KW', label: 'Kuwait' },
  { id: 'KG', label: 'Kyrgyzstan' },
  { id: 'LA', label: 'Laos' },
  { id: 'LV', label: 'Latvia' },
  { id: 'LB', label: 'Lebanon' },
  { id: 'LS', label: 'Lesotho' },
  { id: 'LR', label: 'Liberia' },
  { id: 'LY', label: 'Libya' },
  { id: 'LI', label: 'Liechtenstein' },
  { id: 'LT', label: 'Lithuania' },
  { id: 'LU', label: 'Luxembourg' },
  { id: 'MG', label: 'Madagascar' },
  { id: 'MW', label: 'Malawi' },
  { id: 'MY', label: 'Malaysia' },
  { id: 'MV', label: 'Maldives' },
  { id: 'ML', label: 'Mali' },
  { id: 'MT', label: 'Malta' },
  { id: 'MH', label: 'Marshall Islands' },
  { id: 'MR', label: 'Mauritania' },
  { id: 'MU', label: 'Mauritius' },
  { id: 'MX', label: 'Mexico' },
  { id: 'FM', label: 'Micronesia' },
  { id: 'MD', label: 'Moldova' },
  { id: 'MC', label: 'Monaco' },
  { id: 'MN', label: 'Mongolia' },
  { id: 'ME', label: 'Montenegro' },
  { id: 'MA', label: 'Morocco' },
  { id: 'MZ', label: 'Mozambique' },
  { id: 'MM', label: 'Myanmar' },
  { id: 'NA', label: 'Namibia' },
  { id: 'NR', label: 'Nauru' },
  { id: 'NP', label: 'Nepal' },
  { id: 'NL', label: 'Netherlands' },
  { id: 'NZ', label: 'New Zealand' },
  { id: 'NI', label: 'Nicaragua' },
  { id: 'NE', label: 'Niger' },
  { id: 'NG', label: 'Nigeria' },
  { id: 'MK', label: 'North Macedonia' },
  { id: 'NO', label: 'Norway' },
  { id: 'OM', label: 'Oman' },
  { id: 'PK', label: 'Pakistan' },
  { id: 'PW', label: 'Palau' },
  { id: 'PS', label: 'Palestine' },
  { id: 'PA', label: 'Panama' },
  { id: 'PG', label: 'Papua New Guinea' },
  { id: 'PY', label: 'Paraguay' },
  { id: 'PE', label: 'Peru' },
  { id: 'PH', label: 'Philippines' },
  { id: 'PL', label: 'Poland' },
  { id: 'PT', label: 'Portugal' },
  { id: 'QA', label: 'Qatar' },
  { id: 'RO', label: 'Romania' },
  { id: 'RU', label: 'Russia' },
  { id: 'RW', label: 'Rwanda' },
  { id: 'KN', label: 'Saint Kitts and Nevis' },
  { id: 'LC', label: 'Saint Lucia' },
  { id: 'VC', label: 'Saint Vincent and the Grenadines' },
  { id: 'WS', label: 'Samoa' },
  { id: 'SM', label: 'San Marino' },
  { id: 'ST', label: 'Sao Tome and Principe' },
  { id: 'SA', label: 'Saudi Arabia' },
  { id: 'SN', label: 'Senegal' },
  { id: 'RS', label: 'Serbia' },
  { id: 'SC', label: 'Seychelles' },
  { id: 'SL', label: 'Sierra Leone' },
  { id: 'SG', label: 'Singapore' },
  { id: 'SK', label: 'Slovakia' },
  { id: 'SI', label: 'Slovenia' },
  { id: 'SB', label: 'Solomon Islands' },
  { id: 'SO', label: 'Somalia' },
  { id: 'ZA', label: 'South Africa' },
  { id: 'SS', label: 'South Sudan' },
  { id: 'ES', label: 'Spain' },
  { id: 'LK', label: 'Sri Lanka' },
  { id: 'SD', label: 'Sudan' },
  { id: 'SR', label: 'Suriname' },
  { id: 'SE', label: 'Sweden' },
  { id: 'CH', label: 'Switzerland' },
  { id: 'SY', label: 'Syria' },
  { id: 'TJ', label: 'Tajikistan' },
  { id: 'TZ', label: 'Tanzania' },
  { id: 'TH', label: 'Thailand' },
  { id: 'TL', label: 'Timor-Leste' },
  { id: 'TG', label: 'Togo' },
  { id: 'TO', label: 'Tonga' },
  { id: 'TT', label: 'Trinidad and Tobago' },
  { id: 'TN', label: 'Tunisia' },
  { id: 'TR', label: 'Turkey' },
  { id: 'TM', label: 'Turkmenistan' },
  { id: 'TV', label: 'Tuvalu' },
  { id: 'UG', label: 'Uganda' },
  { id: 'UA', label: 'Ukraine' },
  { id: 'AE', label: 'United Arab Emirates' },
  { id: 'GB', label: 'United Kingdom' },
  { id: 'UY', label: 'Uruguay' },
  { id: 'UZ', label: 'Uzbekistan' },
  { id: 'VU', label: 'Vanuatu' },
  { id: 'VA', label: 'Vatican City' },
  { id: 'VE', label: 'Venezuela' },
  { id: 'VN', label: 'Vietnam' },
  { id: 'YE', label: 'Yemen' },
  { id: 'ZM', label: 'Zambia' },
  { id: 'ZW', label: 'Zimbabwe' },
];
